import { useState } from "react";
import { CommonImages } from "../../../../reusableUI/images";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import { FaRegCalendarAlt } from "react-icons/fa";
import { onCallTrigger } from "../../../../Service/bookings";
import { showToast } from "../../../../reusableUI/toaster";
import Loader from "../../../../reusableUI/loader";

const Oncall = ({ isOpen, onClose, visit }) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [singleDate, setSingleDate] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [status, setStatus] = useState(visit.status);
  const [endDate, setEndDate] = useState(null);
  const [agree, setAgree] = useState(false);
  const [loading, setLoading] = useState();
  const [toastMsg, setToastMsg] = useState(null);
  const visitStartDate = visit?.visitInfo?.startDate;
  const visitEndDate = visit?.visitInfo?.endDate;

  if (!isOpen) return null;

  const handleRadioChange = (value) => {
    setSelectedOption(value);
  };

  // console.log(visit);

  const Save = async (option) => {
    const confirmed = window.confirm("Are you sure you want to save this?");
    if (!confirmed) {
      return;
    }

    const data = {
      type: option,
      visitID: visit._id,
      fromDate: option === "single" ? singleDate : startDate,
      toDate: option === "single" ? singleDate : endDate,
      specialistID: visit.specialistInfo.userID,
    };
    console.log(data);

    try {
      setLoading(true);
      const update = await onCallTrigger(data);
      if (update.error === false) {
        console.log(update.data);
        showToast("Oncall triggered successfully", "Success");
        setTimeout(() => {
          onClose();
        }, 1000);
      } else {
        showToast(update.message || "Failed to trigger oncall.", "Error");
      }
    } catch (err) {
      console.error("Error:", err);
      showToast("Something went wrong. Please try again.", "Error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {loading ? (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
          <div className="flex flex-col items-center bg-white p-5 rounded-md shadow-lg w-96 h-[40vh]">
            <Loader loading={loading} />
          </div>
        </div>
      ) : (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
          <div className="flex flex-col items-start bg-white p-5 rounded-md shadow-lg w-96">
            <div className="flex flex-row justify-between w-full text-md font-semibold mb-4 border-b border-gray-300 pb-4">
              <p className="text-md text-blue-600">Trigger Oncall</p>
              <img
                src={CommonImages.close}
                onClick={onClose}
                className="h-6 w-6 cursor-pointer"
                alt="Close"
              />
            </div>

            <div className="pl-4 mb-4">
              <p className="text-[13px] font-semibold mb-2">Type</p>
              <select
                value={selectedOption}
                onChange={(e) => handleRadioChange(e.target.value)}
                className="border border-blue-500 rounded px-3 py-2 text-[12px] focus:outline-none focus:ring-2 focus:ring-blue-500 w-[300px]"
              >
                <option value="" disabled hidden>
                  Select
                </option>
                <option value="single">Single</option>
                <option value="range">Range</option>
              </select>
            </div>

            {selectedOption === "range" && (
              <div className="flex flex-col items-center mb-6 pl-4 mt-2">
                <div className="flex flex-row items-center justify-center gap-2">
                  <div className="flex flex-row gap-16">
                    <div className="items-center justify-center gap-2">
                      <p className="text-[13px] font-semibold mb-2">
                        From Date
                      </p>

                      <DatePicker
                        value={startDate}
                        onChange={setStartDate}
                        className=" w-full text-[12px]"
                        placeholderText="Select a date"
                        dateFormat="dd/MM/yyyy"
                        clearIcon={null}
                        calendarIcon={
                          <FaRegCalendarAlt color="blue" size={16} />
                        }
                        minDate={new Date(visitStartDate)} // Set the minimum date
                        maxDate={new Date(visitEndDate)} // Set the maximum date
                      />
                    </div>
                    <div className="items-center justify-center gap-2">
                      <p className="text-[13px] font-semibold mb-2">To Date</p>

                      <DatePicker
                        value={endDate}
                        onChange={setEndDate}
                        className=" w-full text-[12px]"
                        placeholderText="Select a date"
                        dateFormat="dd/MM/yyyy"
                        clearIcon={null}
                        calendarIcon={
                          <FaRegCalendarAlt color="blue" size={16} />
                        }
                        minDate={new Date(visitStartDate)} // Set the minimum date
                        maxDate={new Date(visitEndDate)} // Set the maximum date
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            {selectedOption === "single" && (
              <div className="mb-6 pl-4 mt-2">
                <p className="text-[13px] font-semibold mb-2">Start Date</p>

                <DatePicker
                  value={singleDate}
                  onChange={setSingleDate}
                  className=" w-full text-[12px]"
                  placeholderText="Select a date"
                  dateFormat="dd/MM/yyyy"
                  clearIcon={null}
                  calendarIcon={<FaRegCalendarAlt color="blue" size={16} />}
                  minDate={new Date(visitStartDate)}
                  maxDate={new Date(visitEndDate)}
                />
              </div>
            )}

            {/* <div className="mb-6 mt-2">
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={agree}
              onChange={() => setAgree(!agree)}
              color="blue"
              className="mr-2 border-2 border-blue-500 rounded focus:outline-none"
            />
            <p className="text-[12px]">
              Would you like to process a refund for Cancelled day?
            </p>
          </label>
        </div> */}

            <button
              className="bg-custom-gradient text-white p-2 text-[12px] w-24 rounded-md mx-auto mt-4"
              onClick={() =>
                Save(selectedOption === "single" ? "single" : "range")
              }
            >
              Save
            </button>

            <style jsx global>{`
              .react-date-picker__wrapper {
                border: 1px solid #3b82f6; /* Tailwind blue-500 */
                border-radius: 0.375rem; /* rounded-md */
                padding: 0.25rem 0.5rem; /* px-3 py-2 */
                transition: border-color 0.2s ease;
              }

              .react-date-picker__wrapper:focus-within {
                border-color: #2563eb; /* Tailwind blue-600 on focus */
              }

              .react-date-picker__inputGroup {
                font-size: 12px;
              }
            `}</style>
            {/* {toastMsg && (
              <Toaster action={toastMsg.action} msg={toastMsg.msg} />
            )} */}
          </div>
        </div>
      )}
    </div>
  );
};

export default Oncall;
